// See: backend/docs/driver-scheduler.md §11 — GET /schedule
//
// Bir sürücüye ait Gantt satırı: solda sürücü adı + trip sayısı, sağda zaman çubuğu.

import React from "react";

import TripBlock from "./TripBlock";

const LOCKABLE_KINDS = new Set(["SHIFT_PERSONEL", "TRANSFER"]);

const DriverTimelineRow = ({
  row,
  gridStartMin,
  gridEndMin,
  hours,
  onToggleLock,
  busyTripId,
  offLabel,
}) => {
  if (!row) return null;
  const { driver, trips = [], off = false } = row;

  return (
    <div className={`driver-timeline-row${off ? " driver-timeline-row--off" : ""}`}>
      <div className="driver-timeline-row__label">
        <div className="driver-timeline-row__name">
          {driver?.name || "-"}
          {off && offLabel && <span className="driver-timeline-row__off-badge">{offLabel}</span>}
        </div>
        <div className="driver-timeline-row__meta">
          {trips.length > 0 ? `${trips.length} bacak` : "boş"}
        </div>
      </div>
      <div className="driver-timeline-row__grid">
        {/* Saat çizgileri */}
        {hours.map((h) => (
          <div
            key={h}
            className="driver-timeline-row__hour-line"
            style={{
              left: `${((h * 60 - gridStartMin) / (gridEndMin - gridStartMin)) * 100}%`,
            }}
          />
        ))}
        {/* Trip block'ları */}
        {trips.map((trip) => (
          <TripBlock
            key={trip.serviceId}
            trip={trip}
            gridStartMin={gridStartMin}
            gridEndMin={gridEndMin}
            canLock={LOCKABLE_KINDS.has(trip.kind)}
            onToggleLock={onToggleLock}
            isLockBusy={busyTripId === trip.serviceId}
          />
        ))}
      </div>
    </div>
  );
};

export default DriverTimelineRow;
